import axios from 'axios'
import router from '@/router'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: '/prod-api',
    // 超时
    timeout: 10000
})
// request拦截器
service.interceptors.request.use(config => {
    if (config.url.startsWith('/payment')) {
        config.headers['Authorization'] = sessionStorage.getItem('payment_token') || ''
    }
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        if (res.config.url.startsWith('/payment')) {
            if (res.data.code != 200) {
                router.push('/payment/app/empty')
                return Promise.reject('error')
            }
        }
        return res.data
    },
    error => {
        const res = error.response
        if (res && res.config && res.config.url.startsWith('/payment')) {
            if (res.status != 200) {
                router.push('/payment/app/empty')
            }
        }
        return Promise.reject(error)
    }
)

export default service
